import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login/Login';
import Diagram from './components/Diagram/Diagram';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import LibraryManager from './components/LibraryManager/LibraryManager';
import { ColorModeProvider } from './ThemeContext';
// import Poc from './components/Poc';
import SchematicEditor from './components/SchematicEditor/SchematicEditor';
import StickDiagram from './components/StickDiagram/StickDiagram';
import theme from './theme';
import { Container, ThemeProvider  } from '@mui/material';
import CssBaseLine from '@mui/material/CssBaseline';
import Welcome from './components/Login/WelcomePage';
import AccountDetailsForm from './components/Subscription/AccountDetailsForm';
import SubscriptionPlans from './components/Subscription/SubscriptionPlans';
import CheckoutPage from './components/Subscription/CheckoutPage';
import HomePage from './components/HomePage/HomePage'
import Header from './components/HomePage/Header';
import Footer from './components/Footer/Footer';
import MySubscription from './components/HomePage/MySubscription';
import React from 'react';
import Googlerecaptcha from './components/Captcha/Googlerecaptcha';
import Features from './components/Features/Features';
import { useNavigate } from "react-router-dom";

function App() {
  const [openHeader, setOpenHeader] = React.useState(true);
  const [isEditorOpen, setIsEditorOpen] = React.useState(false);

  const handleHeaderToggle = () => setOpenHeader(prev => !prev);

  function AppContent() {
    const navigate = useNavigate();
    React.useEffect(() => {
      const handleLogoutAcrossTabs = (event) => {
        if (event.key === "logout-event") {
          navigate("/");
          window.location.reload();
        }
      };

      window.addEventListener("storage", handleLogoutAcrossTabs);

      return () => {
        window.removeEventListener("storage", handleLogoutAcrossTabs);
      };
    }, [navigate]);

    return null;
  }
  return (
    <>
    <ThemeProvider theme={theme}>
      <CssBaseLine />
      <Router>
        <AppContent />
        <Header open={openHeader} isEditorOpen = {isEditorOpen} />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/captcha" element={<Googlerecaptcha/>} />
          <Route path="/features" element={<Features />} />
          {/* <Route path="/login" element={<Welcome />} /> */}          
          <Route path="/subscribe" element={<SubscriptionPlans />} />
          <Route path="/paymentPage" element={<AccountDetailsForm />} />
          <Route path="/checkoutPage" element={<CheckoutPage />} />
          <Route path='/mysubscription' element ={<MySubscription/>} />
          {/* <Route path="/diagram" element={<ProtectedRoute> <Diagram /> </ProtectedRoute>} /> */}
          <Route path="/practice/:id?" element={<ProtectedRoute><Diagram /></ProtectedRoute>} />
          <Route path="/libraryManager" element={<ProtectedRoute> <LibraryManager/> </ProtectedRoute>} />
            <Route path="/schematicEditor" element={
              <ProtectedRoute>
                <SchematicEditor
                  openHeader={openHeader}
                  toggleHeader={handleHeaderToggle}
                  setIsEditorOpen= {setIsEditorOpen}
                />
              </ProtectedRoute>
            } />
          <Route path="/stick" element={<ProtectedRoute> <StickDiagram/> </ProtectedRoute>} />
        </Routes>
        <Footer/>
      </Router>
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
    </>
  );
}

export default App;
